import { render, staticRenderFns } from "./CardValidaFace.vue?vue&type=template&id=45b1bd37"
import script from "./CardValidaFace.vue?vue&type=script&lang=js"
export * from "./CardValidaFace.vue?vue&type=script&lang=js"
import style0 from "./CardValidaFace.vue?vue&type=style&index=0&id=45b1bd37&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45b1bd37')) {
      api.createRecord('45b1bd37', component.options)
    } else {
      api.reload('45b1bd37', component.options)
    }
    module.hot.accept("./CardValidaFace.vue?vue&type=template&id=45b1bd37", function () {
      api.rerender('45b1bd37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OnboardingDetailPerson/components/CardValidaFace.vue"
export default component.exports